
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewContainerRef,
  forwardRef,
  inject,
  ComponentRef,
  OnDestroy,
  ChangeDetectionStrategy
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GalaxyAbstractFilterInput, GalaxyFilterInputOverride, GalaxyFilterValueInterface } from '../interface';
import { GalaxyFilterOperator } from '../enums';

@Component({
  selector: 'glxy-custom-filter-input',
  template: ` <ng-template #filterOverrideComponent /> `,
  providers: [{ provide: GalaxyAbstractFilterInput, useExisting: forwardRef(() => GalaxyCustomFilterInputComponent) }],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class GalaxyCustomFilterInputComponent implements GalaxyAbstractFilterInput, AfterViewInit, OnDestroy {
  @Input({ required: true }) filterOverride!: GalaxyFilterInputOverride;
  _initialValues: GalaxyFilterValueInterface[] = [];

  @Input() set initialValue(values: GalaxyFilterValueInterface[]) {
    this._initialValues = values;
  }

  _operator?: GalaxyFilterOperator;
  @Input() set operator(value: GalaxyFilterOperator) {
    this._operator = value;
    if (!this.componentRef) return;
    this.componentRef.instance.operator = value;
  }

  @Output() valueChanges = new EventEmitter<GalaxyFilterValueInterface[]>();
  @ViewChild('filterOverrideComponent', { static: false, read: ViewContainerRef }) overrideRef?: ViewContainerRef;
  private componentRef: ComponentRef<GalaxyAbstractFilterInput> | null = null;

  private readonly destroyRef = inject(DestroyRef);

  constructor(private ref: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    if (!this.filterOverride) {
      console.error('No override found for filter input');
      return;
    }

    const viewContainerRef = this.overrideRef;
    if (!viewContainerRef) return;

    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent<GalaxyAbstractFilterInput>(this.filterOverride.filterInput);
    componentRef.instance.operator = this._operator;
    componentRef.instance.initialValue = this._initialValues;
    componentRef.instance.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: GalaxyFilterValueInterface[]) => {
        this.valueChanges.emit(value);
      });
    this.componentRef = componentRef;
    this.ref.detectChanges();
  }

  clearValue() {
    const viewContainerRef = this.overrideRef;
    viewContainerRef?.clear();
    this._initialValues = [];
  }

  ngOnDestroy(): void {
    this.componentRef?.destroy();
    this.componentRef = null;
  }
}
